import {getBearer} from "../functions/getBearer";
import axios from "axios";
import {IAllUserProjects, ITimesheet} from "../models";
import {getApiLink} from "../functions/getApiLink";
import {GetAccessToken} from "./GetAccessToken";
import {setAllUserProjects} from "../storage/toolkit";
import getCookies from "../functions/getCookie";

export async function SetAllUserProjects(dispatch: any, chosenTimesheet?: ITimesheet) {
    // Ensure we have a valid access token before making request
    const token = getCookies('access_token_ces');
    if (!token) {
        console.warn('No access token available for SetAllUserProjects');
        return;
    }

    getBearer("get");
    await axios.get<IAllUserProjects>(getApiLink(`/api/user/projects_info/`)).then(({data}) => {
        dispatch(setAllUserProjects(data))
    }).catch(er => {
        console.error('SetAllUserProjects error:', er);
        er?.response?.status === 401 && GetAccessToken(dispatch, SetAllUserProjects)
    })
}